import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './Services.css';

// Service icons (using emoji as placeholders, would be replaced with proper SVG icons)
const serviceIcons = {
  website: '💻️',
  google: '🔍',
  ads: '📣',
  booking: '📅',
  reputation: '⭐',
  email: '📧'
};

const Services = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);
  const tagRef = useRef(null);
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const servicesRef = useRef(null);
  
  // Animation on scroll
  useEffect(() => {
    const section = sectionRef.current;
    const tag = tagRef.current;
    const title = titleRef.current;
    const description = descriptionRef.current;
    const services = servicesRef.current;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          section.classList.add('visible');
          setTimeout(() => tag.classList.add('visible'), 200);
          setTimeout(() => title.classList.add('visible'), 400);
          setTimeout(() => description.classList.add('visible'), 600);
          setTimeout(() => services.classList.add('visible'), 800);
          
          // Animate service items with staggered delay
          const serviceItems = services.querySelectorAll('.service-item');
          serviceItems.forEach((item, index) => {
            setTimeout(() => item.classList.add('visible'), 800 + (index * 150));
          });
          
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    
    if (section) {
      observer.observe(section);
    }
    
    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);

  return (
    <section className="services" ref={sectionRef}>
      <div className="services-background">
        <div className="services-shape services-shape-1"></div>
        <div className="services-shape services-shape-2"></div>
      </div>
      
      <div className="container">
        <div className="services-content">
          <div className="services-tag" ref={tagRef}>{t('servicesTag')}</div>
          
          <h2 className="services-title" ref={titleRef}>
            {t('servicesTitle')}
          </h2>
          
          <p className="services-description" ref={descriptionRef}>
            {t('servicesDescription')}
          </p>
          
          <div className="services-grid" ref={servicesRef}>
            <div className="service-item">
              <div className="service-icon">{serviceIcons.website}</div>
              <div className="service-content">
                <h3 className="service-title">{t('serviceItem1Title')}</h3>
                <div className="service-text">{t('serviceItem1')}</div>
              </div>
            </div>
            
            <div className="service-item">
              <div className="service-icon">{serviceIcons.google}</div>
              <div className="service-content">
                <h3 className="service-title">{t('serviceItem2Title')}</h3>
                <div className="service-text">{t('serviceItem2')}</div>
              </div>
            </div>
            
            <div className="service-item">
              <div className="service-icon">{serviceIcons.ads}</div>
              <div className="service-content">
                <h3 className="service-title">{t('serviceItem3Title')}</h3>
                <div className="service-text">{t('serviceItem3')}</div>
              </div>
            </div>
            
            <div className="service-item">
              <div className="service-icon">{serviceIcons.booking}</div>
              <div className="service-content">
                <h3 className="service-title">{t('serviceItem4Title')}</h3>
                <div className="service-text">{t('serviceItem4')}</div>
              </div>
            </div>
            
            <div className="service-item">
              <div className="service-icon">{serviceIcons.reputation}</div>
              <div className="service-content">
                <h3 className="service-title">{t('serviceItem5Title')}</h3>
                <div className="service-text">{t('serviceItem5')}</div>
              </div>
            </div>
            
            <div className="service-item">
              <div className="service-icon">{serviceIcons.email}</div>
              <div className="service-content">
                <h3 className="service-title">{t('serviceItem6Title')}</h3>
                <div className="service-text">{t('serviceItem6')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
